import { GridSize } from "@mui/material/Grid";

import { kebabCase } from "lodash";

import { WORD_RECOGNITION_PRESENTATION_TYPES } from "constants/audiology";
import {
  PatientReviewDetail,
  PatientReviewDetailGroup,
  PatientReviewDetailGroupTitle
} from "features/patients/sections/components";
import { WordRecognitionData } from "services/types/reports.type";
import { WordList } from "services/types/word-lists.type";

import PreviewWordList from "./preview-word-list.component";

type PreviewSpeechAudiometryDataGroupProps = {
  data?: WordRecognitionData;
  additionalData?: WordRecognitionData;
  title: string;
  detailSize?: GridSize;
  wordListSize?: GridSize;
  titleSize?: GridSize;
};

export default function PreviewSpeechWordRecognitionDataGroup({
  data,
  additionalData,
  title,
  detailSize,
  wordListSize,
  titleSize
}: PreviewSpeechAudiometryDataGroupProps) {
  return (
    <PatientReviewDetailGroup
      value={data}
      sm={6}
      testId={`word-recognition-data-${kebabCase(title)}`}
    >
      <PatientReviewDetailGroupTitle md={12} lg={titleSize} title={title} />
      <PreviewWordList data={data?.wordList as WordList} size={wordListSize} />
      <PatientReviewDetail
        title="Presentation"
        value={
          data?.presentation
            ? WORD_RECOGNITION_PRESENTATION_TYPES.getFromCode(
                data?.presentation
              )
            : "--"
        }
        size={detailSize}
        lg={2}
        sx={{ minWidth: "130px" }}
      />
      <PatientReviewDetail
        title="DBHL"
        value={data?.dbhl ?? "--"}
        size={detailSize}
        lg={1}
      />
      <PatientReviewDetail
        title="% Correct"
        value={data?.percentCorrect ?? "--"}
        size={detailSize}
        lg={1}
        sx={{ minWidth: "110px" }}
        titleSx={{ whiteSpace: "nowrap" }}
      />
      <PatientReviewDetail
        title="Masking"
        value={data?.masking ?? "--"}
        size={detailSize}
        lg={1}
        sx={{ minWidth: "90px" }}
      />
      <PatientReviewDetail
        title="DBHL"
        value={additionalData?.dbhl ?? "--"}
        size={detailSize}
        lg={1}
      />
      <PatientReviewDetail
        title="% Correct"
        value={additionalData?.percentCorrect ?? "--"}
        size={detailSize}
        lg={1}
        sx={{ minWidth: "110px" }}
        titleSx={{ whiteSpace: "nowrap" }}
      />
      <PatientReviewDetail
        title="Masking"
        value={additionalData?.masking ?? "--"}
        size={detailSize}
        lg={1}
        sx={{ minWidth: "90px" }}
      />
    </PatientReviewDetailGroup>
  );
}
